import { TOGGLE_BUTTON_PARENT_CLASS, ToggleButton } from './toggle-button.js';

export function effects() {
  customElements.define('blocksuite-toggle-button', ToggleButton);
}

export { TOGGLE_BUTTON_PARENT_CLASS, ToggleButton };
